import { render, staticRenderFns } from "./AMeasureProcessTitleSuggestion.vue?vue&type=template&id=96f0c9d2&scoped=true&"
import script from "./AMeasureProcessTitleSuggestion.vue?vue&type=script&lang=ts&"
export * from "./AMeasureProcessTitleSuggestion.vue?vue&type=script&lang=ts&"
import style0 from "./AMeasureProcessTitleSuggestion.vue?vue&type=style&index=0&id=96f0c9d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f0c9d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VIcon,VTooltip})
